import axios from "@/utils/axios2";

export default {
    namespaced: true,
    state: {
        jobcardSpare: null,
        jobcardSpares: null
    },
    mutations: {
        setJobcardSpare(state, payload) {
            state.jobcardSpare = payload;
        },
        setJobcardSpares(state, payload) {
            state.jobcardSpares = payload;
        }
    },
    actions: {
        fetchJobcardSpare({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `jobcard-spares/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setJobcardSpare", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
            });
        },
        fetchJobcardSpares({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `jobcard-spares?jobcard_id=${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setJobcardSpares", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },
        storeJobcardSpare({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `jobcard-spares`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
            });
        },
        updateJobcardSpare({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `jobcard-spares/${payload.id}`,
                    data: payload.form,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                   resolve(response.data); 
                })
                .catch(error => {
                    reject(error.response.data);
                });
            });
        },
        removeJobcardSpare({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `jobcard-spares/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
            });
        }
    }
}